export default __webpack_public_path__ + "static/media/eRx_Active.3dc76aad.svg";